(() => {
  const marker = document.querySelector("[data-coming-soon-v2]");
  if (!marker || marker.dataset.initialized === "true") return;
  marker.dataset.initialized = "true";

  const releaseAtSeconds = Number(marker.dataset.releaseAt);
  const productId = marker.dataset.productId;
  if (!Number.isFinite(releaseAtSeconds) || !productId) return;

  const releaseAt = releaseAtSeconds * 1000;
  const retryKey = `coming-soon-v2:${productId}:${releaseAtSeconds}`;
  const maxRetryDuration = 60_000;
  const retryInterval = 15_000;
  const maxTimeout = 2_147_000_000;

  const hasPurchasableButton = () =>
    Boolean(
      document.querySelector(
        'form[action*="/cart/add"] button[type="submit"]:not([disabled])',
      ),
    );

  const refreshAtRelease = () => {
    if (hasPurchasableButton()) {
      sessionStorage.removeItem(retryKey);
      return;
    }

    const now = Date.now();
    const startedAt = Number(sessionStorage.getItem(retryKey)) || now;
    sessionStorage.setItem(retryKey, String(startedAt));
    if (now - startedAt > maxRetryDuration) {
      sessionStorage.removeItem(retryKey);
      return;
    }

    window.setTimeout(() => window.location.reload(), retryInterval);
  };

  const schedule = () => {
    const remaining = releaseAt - Date.now();
    if (remaining <= 0) {
      refreshAtRelease();
      return;
    }
    window.setTimeout(
      remaining > maxTimeout ? schedule : () => window.location.reload(),
      Math.min(remaining, maxTimeout),
    );
  };

  schedule();
})();
